import styled from 'styled-components';
import { device } from '../../styles/devices';
import type { ThemeProps } from '../../types';

export const Wrapper = styled.div`
  padding: 0 18px;
  @media ${device.tablet} {
    display: flex;
    position: relative;
    padding: 0;
    justify-content: space-between;
    max-height: 500px;
    overflow-y: auto;
  }
`;

export const Details = styled.div`
  font-family: 'Audi Type';
  color: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[100]};
  width: 100%;
  padding: 0;
  @media ${device.tablet} {
    width: 70%;
    padding: 60px 0 40px 40px;
  }
`;

export const HeaderWrap = styled.div`
  display: block;
  margin: 24px 0;
  margin-bottom: 16px;
  @media ${device.tablet} {
    margin-top: 0;
  }
`;

export const DetailsListWrap = styled.div`
  @media ${device.tablet} {
    display: flex;
    justify-content: flex-start;
  }
`;

export const DetailsList = styled.ul`
  margin: 0;
  padding: 0;
  @media ${device.tablet} {
    flex: 1 1 312px;
    margin: 0 22px 0 0;
  }
`;

export const DetailsItem = styled.li`
  margin-bottom: 24px;
`;

export const LegalDisclaimerWrap = styled.div`
  display: flex;
  margin-top: 16px;
  width: 100%;

  p {
    font-size: 12px;
    font-family: 'Audi Type';
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    word-wrap: break-word;
    color: #666666;
    width: 100%;

    @media ${device.tablet} {
      width: 75%;
    }
  }

  @media ${device.tablet} {
    margin-top: 12px;
  }
`;

export const LegalDisclaimerIcon = styled.div`
  height: 24px;
  width: 24px;
  margin-right: 12px;

  svg {
    color: #ffaa00;
  }
`;

export const ImageLegal = styled.div`
  flex: 1 1 300px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 0;
`;

export const VehicleImageWrap = styled.div`
  display: none;
  @media ${device.tablet} {
    width: 100%;
    display: block;
    flex: 1 0 auto;
    width: 400px;
    height: 400px;
  }
`;

export const VehicleImage = styled.img`
  width: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(2);
  position: relative;
  left: 15%;
`;
